export class ConfigDB {
    static data = {
        api: {
            host: process.env.REACT_APP_API_HOST
        },
    }
}

export default ConfigDB;